import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'

import { PopoutMenu } from 'src/ui/PopoutMenu/PopoutMenu'

import CourseList from './subcomponents/CourseList/CourseList'
import CourseSelectorToggle from './subcomponents/CourseSelectorToggle/CourseSelectorToggle'

const CourseSelector = ({
  options,
  onSelectCourse,
  currentlySelectedCourse,
  currentCefrLevel,
}) => {
  const [showPopout, setShowPopout] = useState(false)
  const buttonRef = useRef()

  const handleToggleMenu = () => {
    setShowPopout(!showPopout)
  }

  const handleClose = () => {
    setShowPopout(false)
    buttonRef.current.focus()
  }

  const handleCourseSelection = (val) => {
    handleToggleMenu()
    onSelectCourse(val)
  }

  return (
    <PopoutMenu
      mobileFullscreen={false}
      show={showPopout}
      onClose={handleClose}
      PopoutButton={
        currentlySelectedCourse && (
          <CourseSelectorToggle
            buttonRef={buttonRef}
            showPopout={showPopout}
            course={currentlySelectedCourse}
            onClick={handleToggleMenu}
          />
        )
      }
      PopoutBody={
        <CourseList
          items={options}
          onClick={handleCourseSelection}
          course={currentlySelectedCourse}
          currentCefrLevel={currentCefrLevel}
        />
      }
    />
  )
}

const cefrLevelShape = PropTypes.shape({
  code: PropTypes.string,
  label: PropTypes.string,
})

CourseSelector.propTypes = {
  currentlySelectedCourse: cefrLevelShape,
  currentCefrLevel: cefrLevelShape,
  options: PropTypes.array.isRequired,
  onSelectCourse: PropTypes.func.isRequired,
}

export default CourseSelector
